module.exports = __webpack_public_path__ + "static/media/place-of-worship.eb29bdb5.svg";